// pages/SearchBar.jsx
import React, { useEffect, useMemo, useState } from "react";
import "./../style/searchbar.css";
import { useNavigate } from "react-router-dom";
import { Select } from "antd";
import { FaSearch, FaList } from "react-icons/fa";
import { MdLocationSearching } from "react-icons/md";

const SearchBar = () => {
  const navigate = useNavigate();

  // Categories
  const [categories, setCategories] = useState([]);
  const [catsLoading, setCatsLoading] = useState(true);

  // UI state
  const [selectedCatId, setSelectedCatId] = useState(null);
  const [typedQuery, setTypedQuery] = useState("");
  const [typedLocation, setTypedLocation] = useState("");

  useEffect(() => {
    (async () => {
      try {
        const r = await fetch("https://biz.dropyourbusiness.com/api/categories");
        const data = await r.json();
        setCategories(Array.isArray(data) ? data : []);
      } catch (e) {
        console.error("Error fetching categories:", e);
        setCategories([]);
      } finally {
        setCatsLoading(false);
      }
    })();
  }, []);

  const catOptions = useMemo(
    () =>
      categories.map((c) => ({
        label: c.Category_Name,
        value: String(c.Category_Id),
      })),
    [categories]
  );

  const goToResults = () => {
    const params = new URLSearchParams();
    if (typedQuery.trim()) params.set("keyword", typedQuery.trim());
    if (typedLocation.trim()) params.set("location", typedLocation.trim());
    if (selectedCatId) params.set("category", String(selectedCatId));
    // Results page handles pagination; start at page 1
    params.set("page", "1");
    navigate(`/search?${params.toString()}`);
  };

  return (
    <div className="searchbar-main">
      <div className="big-header-capt">
        <h1>India’s Open Business Directory — List Your Business Free</h1>
      </div>

      <div className="search-bar">
        <div className="search-field">
          <FaSearch className="icon" />
          <input
            type="text"
            placeholder="Keywords..."
            value={typedQuery}
            onChange={(e) => setTypedQuery(e.target.value)}
            onKeyDown={(e) => e.key === "Enter" && goToResults()}
          />
        </div>

        <div className="location-field">
          <MdLocationSearching className="icon" />
          <input
            type="text"
            placeholder="Location..."
            value={typedLocation}
            onChange={(e) => setTypedLocation(e.target.value)}
            onKeyDown={(e) => e.key === "Enter" && goToResults()}
          />
        </div>

        <div className="category-field">
          <FaList className="icon" />
          <Select
            showSearch
            allowClear
            size="large"
            placeholder="Choose Category"
            style={{ width: "100%" }}
            loading={catsLoading}
            options={catOptions}
            optionFilterProp="label"
            filterSort={(a, b) => (a?.label || "").localeCompare(b?.label || "")}
            value={selectedCatId ? String(selectedCatId) : undefined}
            onChange={(val) => setSelectedCatId(val || null)}
          />
        </div>

        <button className="search-button" onClick={goToResults}>
          Search
        </button>
      </div>
    </div>
  );
};

export default SearchBar;
